import React from "react"
import { useAppSelector } from "../../../../../../app/hooks";
import { useRefundSaveMutation, useRefundStatusUpdateMutation } from "../../../../../../services/refundService/refund-api";
import { RefundPostCommand, RefundStatusPostCommand } from "../../../../../../services/refundService/commands";
import { NoAccounts } from "@mui/icons-material";
import { Button } from "@mui/material";
import { IsUspiCenter } from "../../../../specs/IsUspiCenter";

type ownProps={
    setNotify:Function;
    setMessage:Function;}

function RefundToApBtn(props:ownProps){
    const refund = useAppSelector((state)=>state.refundRequest.refundRequest);
    const [refundSave] = useRefundSaveMutation();
    const [saveStatus, result] = useRefundStatusUpdateMutation();
    const isUspiCenter = new IsUspiCenter().IsSatisfiedBy(refund.center);
    const isCreditCard = refund.refundDetail.creditCardRefund;
    
    const getNextStatus = () => {
        if (isCreditCard) return "CREDIT_CARD";
        if (isUspiCenter) return "USPI";
        return "AP";
    };
    
    const getButtonLabel = () => {
        if (isCreditCard) return "Send to Credit Card";
        if (isUspiCenter) return "Send to USPI";
        return "Send to AP";
    };
    
    const getSuccessMessage = () => {
        if (isCreditCard) return "Refund Sent to Credit Card";
        if (isUspiCenter) return "Refund Sent to USPI";
        return "Refund Sent to AP";
    };
    
    const handleToAp=async ()=>{
        await refundSave(new RefundPostCommand(refund));
        await saveStatus(new RefundStatusPostCommand(refund?.caseId,refund?.id,getNextStatus()))
        .unwrap()
        .then(()=>{props.setNotify(true);props.setMessage(getSuccessMessage())})
    }

    return<React.Fragment>
        <Button variant='outlined' color='success' startIcon={<NoAccounts/>}
            onClick={()=>handleToAp()}>{getButtonLabel()}</Button>
    </React.Fragment>
}

export {RefundToApBtn}